<template>
  <div class="line">
    <div class="left">
      <user-photo
        class="user-photo"
        :user="notif.payload.jsoncontent.user"
        @click="markNotificationIsRead"
      />
      <component :is="dynamicComponent" :notif="notif" />
    </div>
    <div class="right">
      <span class="notif-date" @click="deleteNotification()">{{ getDateFromNow(notif.createdAt) }}</span>
    </div>
  </div>
</template>

<script>
import UserPhoto from '@/components/shared/UserPhoto'
import VButton from '@/components/shared/VButton'
import NotifCommentMyPost from './NotifCommentMyPost'
import NotifCommentPostICommented from './NotifCommentPostICommented'
import NotifCommentPostIBookmarked from './NotifCommentPostIBookmarked'
import NotifJoinRequest from './NotifJoinRequest'
import NotifOwnerRequest from './NotifOwnerRequest'
import NotifOwnerCancel from './NotifOwnerCancel'
import NotifJoinRequestResponse from './NotifJoinRequestResponse'
import NotifOwnerResponse from './NotifOwnerResponse'
import NotifJoinMyCommunity from './NotifJoinMyCommunity'
import NotifLikeMyPost from './NotifLikeMyPost'
import NotifPostInCommunity from './NotifPostInCommunity'
import NotifLikeMyComment from './NotifLikeMyComment'
import NotifMentionInPost from './NotifMentionInPost'
import NotifMentionInComment from './NotifMentionInComment'
import NotifRemovedFromCommunity from './NotifRemovedFromCommunity'

export default {
  name: 'NotifLine',
  components: {
    UserPhoto,
    VButton,
    NotifCommentMyPost,
    NotifPostInCommunity,
    NotifCommentPostICommented,
    NotifCommentPostIBookmarked,
    NotifJoinRequest,
    NotifOwnerRequest,
    NotifOwnerCancel,
    NotifJoinRequestResponse,
    NotifOwnerResponse,
    NotifJoinMyCommunity,
    NotifLikeMyPost,
    NotifLikeMyComment,
    NotifMentionInPost,
    NotifMentionInComment,
    NotifRemovedFromCommunity
  },
  props: {
    notif: {
      type: Object,
      required: true
    }
  },
  methods: {
    getDateFromNow (date) {
      let newDate = this.$store.getters.getDateFromNow(date)
      if (newDate.includes('about')) {
        newDate = newDate.substring(6)
      }
      return newDate
    },
    markNotificationIsRead () {
      this.$store.dispatch('markNotificationIsRead', this.notif.id)
    },
    deleteNotification () {
      this.$store.dispatch('deleteNotification', this.notif.id)
    }
  },
  computed: {
    dynamicComponent () {
      switch (this.notif.type) {
        case 'commentMyPost':
          return 'notif-comment-my-post'
        case 'commentPostICommented':
          return 'notif-comment-post-i-commented'
        case 'postInMyCommunity':
        case 'postInCommunityIJoined':
          return 'notif-post-in-community'
        case 'commentPostIBookmarked':
          return 'notif-comment-post-i-bookmarked'
        case 'joinRequestAccepted':
        case 'joinRequestRefused':
          return 'notif-join-request-response'
        case 'ownerRequestAccepted':
        case 'ownerRequestRefused':
          return 'notif-owner-response'
        case 'joinRequest':
          return 'notif-join-request'
        case 'ownerRequest':
          return 'notif-owner-request'
        case 'ownerCancel':
          return 'notif-owner-cancel'
        case 'likeMyPost':
          return 'notif-like-my-post'
        case 'likeMyComment':
          return 'notif-like-my-comment'
        case 'joinMyCommunity':
          return 'notif-join-my-community'
        case 'mentionedInPost':
          return 'notif-mention-in-post'
        case 'mentionedInComment':
          return 'notif-mention-in-comment'
        case 'removedFromCommunity':
          return 'notif-removed-from-community'
        default:
          return ''
      }
    }
  }
}
</script>

<style scoped lang="scss">

.line {
  display:flex;
  justify-content: space-between;
}

.left {
  display:flex;
  align-items: center;
  justify-content: flex-start;
  .wording {
    text-align: left;
    font-size: 14px;
  }
  .btn-container {
    display:flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-top: 8px;
    .btn {
      margin: 2px 10px 2px 0;
    }
  }
}

.right {
  display:flex;
  align-items: center;
  justify-content: flex-end;
  //min-width: 140px;
}

.user-photo {
  margin-right: 13px;
  height: 48px;
  align-self: flex-start;
}

.link {
  color: $primary-color;
  cursor: pointer;
}

.notif-date {
    font-size: 13px;
    color: #999999;
    letter-spacing: 0;
    text-align: right;
    line-height: 19px;
}

.line .right .notif-date {
  text-align: center;
}

.line .right .notif-date::after {
    width: 25px;
    margin: auto;
    content: url(../../assets/Close.svg);
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
}

.button-disabled {
    height: 32px;
    border-radius: 3px;
    padding: 0 12px;
    font-size: 13px;
    letter-spacing: 0;
    text-align: center;
    background:#9B9B9B;
    color: #FFFFFF;
    cursor: default;
    border: none;
}

</style>
